document.addEventListener('DOMContentLoaded', () => {
  const initialShowCount = 9; // Cantidad inicial de artículos a mostrar
  const loadMoreCount = 3; // Cantidad de artículos a mostrar después de hacer clic en el botón

  const projectGrid = document.getElementById('project__grid');
  const loadMoreButton = document.getElementById('btn__load-more');

  if (!projectGrid || !loadMoreButton) {
    return;
  }

  const articles = projectGrid.querySelectorAll('article');
  let currentShowCount = initialShowCount;

  // Función para mostrar artículos
  const showArticles = (count: number) => {
    articles.forEach((article, index) => {
      if (index < count) {
        article.classList.remove('hidden');
      } else {
        article.classList.add('hidden');
      }
    });

    // Ocultar el botón si se han mostrado todos los artículos
    if (count >= articles.length) {
      loadMoreButton.style.display = 'none';
    } else {
      loadMoreButton.style.display = 'block';
    }
  };

  // Mostrar los artículos iniciales
  showArticles(currentShowCount);

  // Manejar el evento de clic en el botón "Load More"
  loadMoreButton.addEventListener('click', () => {
    currentShowCount += loadMoreCount;
    showArticles(currentShowCount);
  });
});